import axios, { AxiosResponse } from 'axios';

import { SearchRequest } from 'core/util/Search';

export enum FieldName {
    Id = '__admin_role_id__',
    ActionId = '__admin_role_actionID__',
    Name = '__admin_role_name__',
    Search = '__role_search__',
    AgencyId = '__admin_role_agencyID__',
    TenantId = '__admin_role_tenantID__',
    RepbizRoleId = 'id',
    ManagedRolesNone = '5df27b5aa2959d8f53e40fb2',
}

export interface Role {
    actionIDs: string[];
    active: boolean;
    agencyID: number;
    cloned: boolean;
    description: string;
    externalID: string;
    id: string;
    managedRoleIDs: string[];
    name: string;
    originalSourceID: string;
    parentRoleID: string;
    roleID: number;
    clonedFromId?: string;
}

interface GetRolesArgs {
    basic: boolean;
}

export interface RoleDetailsType {
    isEdit?: boolean;
    isAdd?: boolean;
    isEditEnabled?: boolean;
    role?: Partial<Role>;
    agencyId: string;
    tenantId: string;
    roleId?: string;
}

export const getRoles = async (
    agencyId: number,
    tenantId: number,
    search?: SearchRequest,
    args?: GetRolesArgs,
): Promise<Role[]> => {
    const params: any = { agencyId, tenantId, search, args };

    const response: AxiosResponse = await axios.get(`/api/tenants/${tenantId}/roles`, {
        params,
    });

    return response.data;
};

export const countRoles = async (agencyId: number, tenantId: number, search?: SearchRequest): Promise<number> => {
    const params: any = { agencyId, tenantId, search };

    const response: AxiosResponse = await axios.put(`/api/tenants/${tenantId}/roles/count`, params);

    return response.data?.count || 0;
};

export const saveRole = async (agencyId: number, tenantId: number, role: Partial<Role>, args?: any): Promise<Role> => {
    const response: AxiosResponse = await axios.post(`/api/tenants/${tenantId}/roles`, {
        agencyId,
        tenantId,
        role,
        args,
    });

    return response.data;
};

export const deleteRole = async (agencyId: number, tenantId: number, roleId: string, args?: any): Promise<string> => {
    const params: any = { agencyId, tenantId, roleId, args };

    const response: AxiosResponse = await axios.delete(`/api/tenants/${tenantId}/roles/${roleId}`, {
        params,
    });

    return response.data;
};

export const getRole = async (agencyId: number, tenantId: number, roleId: string, args?: any): Promise<Role> => {
    const params: any = { agencyId, tenantId, roleId, args };

    const response: AxiosResponse = await axios.get(`/api/tenants/${tenantId}/roles/${roleId}`, {
        params,
    });

    return response.data;
};
